import { render, staticRenderFns } from "./BscTransactions.vue?vue&type=template&id=3d6059f4"
import script from "./BscTransactions.vue?vue&type=script&lang=js"
export * from "./BscTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports